// ErrorMessage.jsx
import React from "react";

const ErrorMessage = ({ error }) => {
  return error ? <p className="error">{error}</p> : null;
};

export default ErrorMessage;
